import { render, staticRenderFns } from "./Skill.vue?vue&type=template&id=a144d296&scoped=true"
import script from "./Skill.vue?vue&type=script&lang=js"
export * from "./Skill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a144d296",
  null
  
)

export default component.exports